
import { h } from "preact";
import Router, { RoutableProps } from "preact-router";
import { LabelEditPage } from "./edit";
import { baseUrl } from "../../App";
import { LabelTemplatePage } from "./template";
import { LabelHomePage } from "./home";
import { LabelFilesHomePage, LabelFilesPage } from "./files";
import { LabelEditOldPage } from "./edit-old";
import { LabelGroupPage } from "./group";

export function LabelPage(props: RoutableProps) {
    return <Router>
        <LabelHomePage path={`${baseUrl}/label`}/>
        <LabelEditPage path={`${baseUrl}/label/:id`}/>
        <LabelEditOldPage path={`${baseUrl}/label/edit-old/:id`}/>
        <LabelEditPage path={`${baseUrl}/label/new`}/>
        <LabelTemplatePage path={`${baseUrl}/label/template/:id?`}/>
        <LabelFilesPage path={`${baseUrl}/label/files/:rest*`}/>
        <LabelGroupPage path={`${baseUrl}/label/group/:id?`}/>
    </Router>
}
